interface ObjectWithValues {
  [key: string]: any;
}

const formatObjEmpty = (obj: ObjectWithValues): ObjectWithValues => {
  const newObj: ObjectWithValues = {};
  Object.keys(obj).forEach((key) => {
    if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
      newObj[key] = obj[key];
    }
  });
  return newObj;
};

export default formatObjEmpty;
